import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "rounded-r-lg w-32 bg-gray-300 h-4" }

import { computed } from "vue";
import { useStore } from "vuex";

interface Skill {
  experience: number;
  name: string;
  type: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SkillBarItem',
  props: {
    skill: {},
    type: {}
  },
  setup(__props: any) {

const props = __props;

const store = useStore();
const isDarkMode = computed(() => store.getters.isDarkMode);

const getClass = computed((): string => {
  const experience = props.skill.experience;
  switch (experience) {
    case 1:
      return "w-" + props.skill.experience + "/5 bg-gray-400";
    case 2:
      return "w-" + props.skill.experience + "/5 bg-gray-400";
    case 3:
      return "w-" + props.skill.experience + "/5 bg-blue-300";
    case 4:
      return "w-" + props.skill.experience + "/5 bg-blue-400";
    case 5:
      return "w-" + props.skill.experience + "/5 bg-green-600";
    default:
      return "w-" + props.skill.experience + "/5 bg-gray-800";
  }
});

return (_ctx: any,_cache: any) => {
  return (_ctx.type ? _ctx.skill.type === _ctx.type : true)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("span", {
          class: _normalizeClass(["font-bold text-sm", [isDarkMode.value ? 'text-gray-200' : 'text-gray-700']])
        }, _toDisplayString(_ctx.skill.name), 3),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["rounded-r-lg h-full", getClass.value])
          }, " ", 2)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})